export const MINOR = "Minor";
export const MODERATE = "Moderate";
export const MAJOR = "Major";
export const COMPLEX = "Complex";

export const MINOR_TIMERANGE = "Up to 4 hours";
export const MODERATE_TIMERANGE = "Up to 8 hours";
export const MAJOR_TIMERANGE = "Up to 12 hours";
export const COMPLEX_TIMERANGE = "+12 hours";
